"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unrotateShadowOffset = void 0;
var rotateVector2_1 = require("./rotateVector2");
/**
 * Ensures shadows stay in the same position while rotating objects.
 */
function unrotateShadowOffset(object) {
    return rotateVector2_1.rotateVector2(object.shadowOffsetX, object.shadowOffsetY, -object.angle);
}
exports.unrotateShadowOffset = unrotateShadowOffset;
//# sourceMappingURL=unrotateShadowOffset.js.map